import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import colorStyle from '@/components/mapv2/colorstyle';
let _ = require('lodash');
export default {
  props: {
    index: {
      type: Number,
      default: 1
    },
    value: {
      type: Array,
      default: []
    },
    name: {
      type: String,
      default: ''
    },
    showTab: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '按钮'
    }
  },
  components: {
    colorStyle
  },
  data() {
    return {
      switchtab2: '0',
      switchIndex: 0,
      defaultData: [],
      form: {}
    };
  },
  watch: {
    value: {
      handler(val) {
        if (val) {}
      },
      deep: true
    },
    index: {
      handler(val) {
        if (val) {
          console.log(`index`, val);
          // value个数大于1触发
          if (this.value.length > 1 && this.value.length !== this.defaultData.length) this.defaultData = _.cloneDeep(this.value);
          if (val - 2 === this.defaultData.length) {
            // 默认第一条数据样式
            let defaultstyle = this.defaultData[0];
            this.defaultData.forEach(elem => {
              elem.style = defaultstyle.style;
            });
          }
          this.switchtab2 = '0';
          this.handleClick({
            index: 0
          });
        }
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      console.log(`fillcolormounted`, this.value);
      this.defaultData = _.cloneDeep(this.value);
      this.form = _.cloneDeep(this.defaultData[0].style[0]);
      console.log(`this.form`, this.form);
      this.form.stroke.lineDash = this.form.stroke.lineDash.map(item => {
        return item / this.form.stroke.width;
      });
      this.getDashType(this.form.stroke.lineDash);
    });
  },
  methods: {
    getDashType(val) {
      switch (JSON.stringify(val)) {
        case JSON.stringify([2, 2, 4]):
          this.form.stroke.type = 2;
          break;
        case JSON.stringify([4, 2]):
          this.form.stroke.type = 3;
          break;
        case JSON.stringify([2, 2]):
          this.form.stroke.type = 4;
          break;
        default:
          this.form.stroke.type = 1;
          break;
      }
    },
    handleClick(val) {
      this.switchIndex = Number(val.index);
      console.log(`this.index`, this.index);
      console.log(`this.switchIndex`, this.switchIndex);
      console.log(`this.defaultData`, this.defaultData);
      console.log(`this.value`, this.value);
      if (this.value.length === 1 && this.value.length !== this.defaultData.length) this.defaultData = _.cloneDeep(this.value);
      // 选中样式 全部或部分更新 值为'' 全部
      let dindex = this.index - 2 === this.defaultData.length ? '' : this.index - 1 === 999 ? 0 : this.index - 1;
      console.log(`dindex`, dindex);
      if (this.switchIndex === 1 && dindex !== '' && this.defaultData[dindex].style.length === 1) {
        this.defaultData[dindex].style.push(this.defaultData[dindex].style[0]);
      }
      if (this.switchIndex === 1 && dindex === '' && this.defaultData[0].style.length === 1) {
        this.defaultData.forEach(item => {
          if (item.style.length === 1) item.style.push(item.style[0]);
        });
      }
      this.form = _.cloneDeep(this.defaultData[dindex === '' ? 0 : dindex].style[this.switchIndex]);
      this.form.stroke.lineDash = this.form.stroke.lineDash.map(item => {
        return item / this.form.stroke.width;
      });
      this.getDashType(this.form.stroke.lineDash);
      console.log(`this.form`, this.form);
    },
    fillcolorChange(val, title) {
      console.log(`val`, val);
      console.log(`title`, title);
      let lineDash = [];
      switch (this.form.stroke.type) {
        case 2:
          lineDash = [2, 2, 4];
          break;
        case 3:
          lineDash = [4, 2];
          break;
        case 4:
          lineDash = [2, 2];
          break;
        default:
          lineDash = [];
          break;
      }
      this.form.stroke.lineDash = lineDash.map(item => {
        return this.form.stroke.width * item;
      });
      if (title === 'fill') this.form.fill = val;

      // 选中样式 全部或部分更新 值为'' 全部
      let dindex = this.index - 2 === this.defaultData.length ? '' : this.index - 1 === 999 ? 0 : this.index - 1;
      console.log(dindex);
      if (dindex !== '') {
        this.defaultData[dindex].style = this.defaultData[dindex].style.map((item, index) => {
          if (index === this.switchIndex) item = _.cloneDeep(this.form);
          return item;
        });
      } else {
        this.defaultData = this.defaultData.map(item => {
          item.style = item.style.map((style, index) => {
            if (index === this.switchIndex) style = _.cloneDeep(this.form);
            return style;
          });
          return item;
        });
      }
      console.log(`this.defaultData`, this.defaultData);
      // return
      this.$emit('change', this.defaultData);
      // 当前index 当前switch  [normal, select]
    }
  }
};